module.exports = {
  setOrder: (state, obj) => {
    state.data = obj
  },
  setError: (state, bool) => {
    state.error = bool
  },
  setHandoffMode: (state, str) => {
    state.handoffMode = str
  },
  setOrderMode: (state, str) => {
    state.orderMode = str
  },
  setSelectedDay: (state, str) => {
    state.selectedDay = str
  },
  setSelectedTime: (state, str) => {
    state.selectedTime = str
  },
  setAsapUnavailable: (state, obj) => {
    state.asapUnavailable = obj
  },
  setDeliveryStatus: (state, obj) => {
    state.deliveryStatus = obj
  }
}